import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  postSubadmin,
  updateSubadmin,
  getSubadminById,
  customerList,
  getRoleList,
  getDetailSettings,
  fileUpload,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRef } from "react";
import Loading from "../../../Common/extra/loading";
import PhoneInput from "react-phone-input-2";
import { MenuItem, Select } from "@material-ui/core";
import { checkValidations } from "../../../Services/Helper";
import { isEmail, isEmpty, isMobilePhone } from "validator";

const StatusList = [
  {
    name: "Active",
    id: "1",
  },
  {
    name: "Inactive",
    id: "0",
  },
];

const DeleteList = [
  {
    name: "On",
    id: "1",
  },
  {
    name: "Off",
    id: "0",
  },
];

const AddSubAdminIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const compMounted = useRef();
  const [loading, setLoading] = useState(false);
  const [Permissions, setPermissions] = useState([]);
  const userData = useSelector((s) => s?.Signatures?.subadmin?.data);
  const UserList = useSelector((s) => s?.Customers?.user?.data);
  const RoleList = useSelector((s) => s?.Signatures?.roles?.data);
  const basicSettings = useSelector(
    (s) => s?.Signatures?.detailSettings?.data?.contact_address
  );

  const [state, setState] = useState({
    orderBy: "sort_index",
    order: "asc",
    page: 0,
    limit: 10,
    searchBy: "email",
    search: "",
    tab: "all",
    archive: "0",
    admin_id: "",
  });

  useEffect(() => {
    setState((pre) => ({
      ...pre,
      admin_id: localStorage && localStorage.getItem("id"),
    }));
  }, []);

  const { editId } = useParams();
  const [data, setData] = useState({
    userId: "",
    name: "",
    last_name: "",
    email: "",
    fax: "",
    office: "",
    office_address: "",
    company_title: "",
    mobile_number: "",
    role_permission: "",
    permissions: [],
    profile_image: "",
    clients: [],
    soft_delete: "0",
    role: "subadmin",
  });

  const [errors, setError] = useState({
    name: "",
    last_name: "",
    email: "",
    fax: "",
    office: "",
    office_address: "",
    company_title: "",
    mobile_number: "",
    role_permission: "",
    permissions: [],
    profile_image: "",
    clients: [],
    disabled: true,
  });

  useEffect(() => {
    if (state.admin_id) {
      dispatch(customerList(state));
      dispatch(getDetailSettings());
    }
  }, [state.admin_id]);

  useEffect(() => {
    if (RoleList) {
      let permit =
        RoleList && RoleList?.filter((item) => item.id == data.role_permission);
      if (permit && !editId) {
        setPermissions(permit[0]?.permissions || []);
        setData((pre) => ({
          ...pre,
          permissions: permit[0]?.permissions || [],
        }));
      } else {
        setPermissions(permit[0]?.permissions || []);
      }
    }
  }, [data.role_permission, RoleList]);

  useEffect(() => {
    if (compMounted.current) {
      setData((pre) => ({
        ...pre,
        name: userData?.name ? userData?.name : "",
        profile_image: userData?.profile_image ? userData?.profile_image : "",
        email: userData?.email ? userData?.email : "",
        office_address: userData?.office_address
          ? userData?.office_address
          : "",
        mobile_number: userData?.mobile_number
          ? userData?.mobile_number.replace(/[\D]/g, "")
          : "",
        permissions: userData?.permissions ? userData?.permissions : [],
        last_name: userData?.last_name ? userData?.last_name : [],
        fax: userData?.fax ? userData?.fax : [],
        office: userData?.office ? userData?.office : [],
        clients:
          userData?.clients && userData?.clients.length > 0
            ? userData?.clients.map((itm) => itm.id)
            : [],
        company_title: userData?.company_title ? userData?.company_title : [],
        role_permission: userData?.role_permission
          ? userData?.role_permission
          : "",
        status: userData?.status ? userData?.status : "1",
        soft_delete: userData?.soft_delete ? userData?.soft_delete : "1",
      }));
    } else {
      compMounted.current = true;
    }
  }, [userData]);
  useEffect(() => {
    if (editId) {
      dispatch(getSubadminById(editId));
    }
    setData((pre) => ({
      ...pre,
      userId: editId,
    }));
  }, [editId]);

  useEffect(() => {
    dispatch(getRoleList());
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const Error = { ...errors };

    switch (name) {
      case "name":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;

          ("");
        }
        break;

      case "last_name":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;

          ("");
        }
        break;

      // case "fax":
      //   Error[name] = "";
      //   if (value.length < 1) {
      //     Error[name] = "Required";
      //     Error["disabled"] = true;
      //   } else {
      //     Error["disabled"] = false;

      //     ("");
      //   }
      //   break;

      // case "office":
      //   Error[name] = "";
      //   if (value.length < 1) {
      //     Error[name] = "Required";
      //     Error["disabled"] = true;
      //   } else {
      //     Error["disabled"] = false;

      //     ("");
      //   }
      //   break;

      case "company_title":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;

          ("");
        }
        break;

      case "email":
        if (isEmpty(value)) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else if (!isEmail(value)) {
          Error[name] = "Invalid Email";

          Error["disabled"] = true;
        } else {
          Error[name] = "";
          Error["disabled"] = true;
        }
        break;

      default:
        break;
    }
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handleMultipleChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({ ...pre, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let validateFields = {
      company_title: data.company_title,
      email: data.email,
      last_name: data.last_name,
      mobile_number: data.mobile_number,
      name: data.name,
      office_address: data.office_address,
      permissions: data.permissions,
      role: data.role,
      role_permission: data.role_permission,
    };

    const validate = checkValidations(validateFields);
    const callBack = (response) => {
      setLoading(false);
      if (response.data) {
        toast.success("Added Successfully");
        setTimeout(() => {
          navigate("/subadmins");
        }, 500);
      } else {
        setLoading(false);
      }
    };
    if (
      (validate.error == "UserId is required!" &&
        data.permissions.length > 0) ||
      (!validate.error && data.permissions.length > 0)
    ) {
      setLoading(true);
      if (editId) {
        if (data.userId) {
          data.userId = data.userId;
        }
        dispatch(
          updateSubadmin(
            {
              userId: data.userId,
              name: data.name,
              profile_image: data.profile_image,
              last_name: data.last_name,
              email: data.email,
              office_address: data.office_address,
              office: data.office,
              fax: data.fax,
              company_title: data.company_title,
              mobile_number: "+" + data.mobile_number,
              role_permission: data.role_permission,
              permissions: data.permissions,
              clients: JSON.stringify(data.clients),
              soft_delete: data.soft_delete,
              role: "subadmin",
            },
            callBack
          )
        );
      } else {
        dispatch(
          postSubadmin(
            {
              userId: data.userId,
              name: data.name,
              profile_image: data.profile_image,
              last_name: data.last_name,
              email: data.email,
              office_address: data.office_address,
              office: data.office,
              fax: data.fax,
              company_title: data.company_title,
              mobile_number: "+" + data.mobile_number,
              role_permission: data.role_permission,
              permissions: data.permissions,
              clients: JSON.stringify(data.clients),
              role: "subadmin",
            },
            callBack
          )
        );
      }
    } else {
      if (data.name == "") {
        setError((pre) => ({ ...pre, name: "Required" }));
      }
      if (data.last_name == "") {
        setError((pre) => ({ ...pre, last_name: "Required" }));
      }
      if (data.email == "") {
        setError((pre) => ({ ...pre, email: "Required" }));
      }
      // if (data.fax == "") {
      //   setError((pre) => ({ ...pre, fax: "Required" }));
      // }

      // if (data.office == "") {
      //   setError((pre) => ({ ...pre, office: "Required" }));
      // }
      if (data.company_title == "") {
        setError((pre) => ({ ...pre, company_title: "Required" }));
      }
      // if (data.profile_image == "") {
      //   setError((pre) => ({ ...pre, profile_image: "Required" }));
      // }
      if (data.role_permission == "") {
        setError((pre) => ({ ...pre, role_permission: "Required" }));
      }
      if (!data.role_permission == "" && data.permissions.length < 1) {
        setError((pre) => ({ ...pre, permissions: "Required" }));
      }
    }
  };

  useEffect(() => {
    if (data.role_permission !== "") {
      setError((pre) => ({ ...pre, role_permission: "" }));
    }
    if (data.permissions.length !== 0) {
      setError((pre) => ({ ...pre, permissions: "" }));
    }
  }, [data]);

  const handlePhone = (name, phoneNumber, dialCode, validate) => {
    if (!phoneNumber || !dialCode) return false;
    const Error = { ...errors };
    switch (name) {
      case "mobile_number":
        if (!validate) {
          Error[name] = "Invalid Number";
        } else {
          Error[name] = "";
        }
        break;

      default:
        break;
    }
    setData((pre) => ({
      ...pre,
      [name]: phoneNumber,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handleFileProvider = (event) => {
    setLoading(true);
    let image = event.target.files[0];
    let formData = new FormData();
    formData.append("project_image[]", image);

    const callback = (url) => {
      setData((pre) => ({ ...pre, profile_image: url?.files[0] }));
      setLoading(false);
    };

    dispatch(fileUpload(formData, null, callback));
  };
  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/subadmins">Team</Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    {editId ? "Edit" : "Add"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="12" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Profile Image
                      </label>
                      <div className="upload-file position-relative">
                        <input
                          type="file"
                          onChange={(e) => handleFileProvider(e)}
                          className="position-absolute"
                        />
                        <div className="inner position-relative">
                          <img
                            src={
                              data?.profile_image
                                ? data?.profile_image
                                : "/assets/images/dummy-profile"
                            }
                            alt=""
                            className="img-fluid w-100 h-100 rounded-circle"
                          />
                          <span className="btn rounded-circle d-flex align-items-center justify-content-center position-absolute">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                            >
                              <path
                                d="M5.2125 11.1975L8.3925 6.9525L14.76 1.65C15.0525 1.3575 15.54 1.3575 15.8175 1.65L16.35 2.1825C16.6425 2.46 16.6425 2.9475 16.35 3.24L11.0475 9.6075L6.8025 12.7875L5.2125 11.1975M6.27 13.32L4.68 11.73L2.5575 12.7875L1.5 15.9675L3.09 14.3775C3.24 14.25 3.4725 14.25 3.6225 14.3775C3.75 14.5275 3.75 14.76 3.6225 14.91L2.0325 16.5L5.2125 15.4425L6.27 13.32Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                      <p className="small-text m-0 text-muted">
                        Max. upload file size: 5MB
                      </p>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.profile_image}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={data?.name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.name}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="last_name"
                        value={data.last_name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.last_name}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={data?.email}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.email}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Mobile Phone (optional)
                      </label>
                      <PhoneInput
                        country={"us"}
                        value={data.mobile_number}
                        placeholder="Mobile Phone"
                        onChange={(data, country) => {
                          let validateWithLength = country.format?.split(".");
                          validateWithLength = validateWithLength?.length - 1;
                          if (validateWithLength == data.length) {
                            handlePhone(
                              "mobile_number",
                              data,
                              country.dialCode,
                              true
                            );
                          } else {
                            handlePhone(
                              "mobile_number",
                              data,
                              country.dialCode,
                              false
                            );
                          }
                        }}
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.mobile_number}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Address
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="office_address"
                        value={data.office_address}
                        onChange={handleChange}
                        MenuProps={basicSettings}
                      >
                        {basicSettings &&
                          basicSettings.length > 0 &&
                          basicSettings.map((item, idx) => {
                            return (
                              <MenuItem key={item} value={item}>
                                {item}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.office_address}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Office No
                      </label>
                      <input
                        type="number"
                        name="office"
                        value={data.office}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.office}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Title/Position in Company
                      </label>
                      <input
                        type="text"
                        name="company_title"
                        value={data.company_title}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.company_title}
                      </span>
                    </Col>

                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Fax No
                      </label>
                      <input
                        type="number"
                        name="fax"
                        value={data.fax}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.fax}
                      </span>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Role
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        name="role_permission"
                        value={data.role_permission}
                        onChange={handleChange}
                        MenuProps={RoleList}
                      >
                        {RoleList &&
                          RoleList.length > 0 &&
                          RoleList.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.role_permission}
                      </span>
                    </Col>
                    {data.role_permission !== "" && (
                      <Col lg="6" className="my-2 doc-select">
                        <label htmlFor="" className="form-label2 m-0">
                          Permissions
                        </label>
                        <Select
                          className="demo-simple-select-label"
                          id="demo-simple-select"
                          multiple
                          name="permissions"
                          value={data.permissions}
                          onChange={handleMultipleChange}
                          MenuProps={Permissions.length > 0 ? Permissions : []}
                        >
                          {Permissions &&
                            Permissions.length > 0 &&
                            Permissions.map((item, idx) => {
                              return (
                                <MenuItem key={item} value={item}>
                                  {item}
                                </MenuItem>
                              );
                            })}
                        </Select>
                        <span className="note error_note py-2 m-0 text-danger">
                          {errors.permissions}
                        </span>
                      </Col>
                    )}
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Clients Assign
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        multiple
                        name="clients"
                        value={data.clients}
                        onChange={handleMultipleChange}
                        MenuProps={UserList || []}
                      >
                        {UserList &&
                          UserList.length > 0 &&
                          UserList.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.amtaxsettlement_data &&
                                  JSON.parse(item.amtaxsettlement_data)
                                    .FirstName +
                                    " " +
                                    JSON.parse(item.amtaxsettlement_data)
                                      .LastName}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.clients}
                      </span>
                    </Col>
                    {data.userId && (
                      <>
                        <Col lg="6" className="my-2 doc-select">
                          <label htmlFor="" className="form-label2 m-0">
                            Status
                          </label>
                          <Select
                            className="demo-simple-select-label"
                            id="demo-simple-select"
                            name="status"
                            value={data.status}
                            onChange={handleChange}
                            MenuProps={StatusList}
                          >
                            {StatusList &&
                              StatusList.length > 0 &&
                              StatusList.map((item, idx) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </Col>
                        <Col lg="6" className="my-2 doc-select">
                          <label htmlFor="" className="form-label2 m-0">
                            Turn On/Off
                          </label>
                          <Select
                            className="demo-simple-select-label"
                            id="demo-simple-select"
                            name="soft_delete"
                            value={data.soft_delete}
                            onChange={handleChange}
                            MenuProps={DeleteList}
                          >
                            {DeleteList &&
                              DeleteList.length > 0 &&
                              DeleteList.map((item, idx) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </Col>
                      </>
                    )}
                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          onClick={handleSubmit}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/subadmins`}
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddSubAdminIndex;
